import React from "react";

const RELOAD_FLAG = "medisure-chunk-reloaded";

/**
 * Drop-in replacement for React.lazy that survives stale-chunk errors.
 *
 * After a redeploy, clients still running the old build request chunk hashes
 * that no longer exist → "ChunkLoadError". Instead of crashing into the error
 * boundary, we force a one-time full reload to pull the fresh build. The
 * sessionStorage flag prevents an infinite reload loop if the failure is real.
 */
export function lazyWithRetry(factory) {
  return React.lazy(() =>
    factory().catch((error) => {
      const alreadyReloaded = window.sessionStorage.getItem(RELOAD_FLAG);
      if (!alreadyReloaded) {
        window.sessionStorage.setItem(RELOAD_FLAG, "1");
        window.location.reload();
        // Halt this import while the page reloads.
        return new Promise(() => {});
      }
      throw error;
    })
  );
}

/** Call once the app has successfully mounted to re-arm reload-on-next-deploy. */
export function clearChunkReloadFlag() {
  window.sessionStorage.removeItem(RELOAD_FLAG);
}
